import factory from './DescrowFactory.json';
import descrow from './Descrow.json';

const factoryAddress = "0xF618dcA7f04993567790B336c18982c96604DAB1";
const factoryAbi = factory.abi;
const descrowAbi = descrow.abi;

export { factoryAddress, factoryAbi, descrowAbi }

